
import { defineComponent } from 'vue'

// presentation information
interface PresentationInfo {
  title: string,
  author: string,
  conference: string,
  location: string,
  date: string,
  invited: boolean,
  number?: string,
  note?: string
}

export default defineComponent({
  data () {
    return {
      presentations: [
        {
          title: 'Phase-modulated Fulde–Ferrell superconductivity via altermagnetism',
          author: '<u>Shuntaro Sumita</u>, Makoto Naka, and Hitoshi Seo',
          conference: 'The 16th International Symposium on Crystalline Organic Metals, Superconductors and Magnets',
          location: 'Loisir Hotel (Toyohashi, Japan)',
          date: 'September 2025',
          invited: false
        },
        {
          title: 'Altermagnetism-induced Fulde–Ferrell state',
          author: '<u>Shuntaro Sumita</u>, Makoto Naka, and Hitoshi Seo',
          conference: 'Conference on Strongly Correlated Electron Systems 2025',
          location: 'Montreal Bonaventure Hotel (Montréal, Canada)',
          date: 'July 2025',
          invited: false
        },
        {
          title: 'Anisotropy-induced spin parity effect in an antiferromagnetic spin chain',
          author: '<u>Shuntaro Sumita</u>, Akihiro Tanaka, and Yusuke Kato',
          conference: 'APS March Meeting 2024',
          location: 'Minneapolis Convention Center (Minneapolis, USA)',
          date: 'March 2024',
          invited: false
        },
        {
          title: 'Finite-momentum superconductivity in altermagnetic κ-type organic compounds',
          author: '<u>Shuntaro Sumita</u>, Makoto Naka, and Hitoshi Seo',
          conference: 'Trends in the Theory of Quantum Materials 2023',
          location: 'Kofu-Kaikan (Chiba, Japan)',
          date: 'October 2023',
          invited: false
        },
        {
          title: 'Weyl superconductivity induced by supercurrent flow',
          author: '<u>Shuntaro Sumita</u> and Kazuaki Takasan',
          conference: 'APS March Meeting 2023',
          location: 'Caesars Forum Convention Center (Las Vegas, USA)',
          date: 'March 2023',
          invited: false,
          number: 'K25.00010'
        },
        {
          title: 'SNS junction of topological superconductors revisited: Fractional Josephson current, fermion parity, and oscillating wave functions',
          author: '<u>Shuntaro Sumita</u>',
          conference: 'Novel Quantum States in Condensed Matter 2022',
          location: 'Kyoto Univ. (Kyoto, Japan)',
          date: 'November 2022',
          invited: false
        },
        {
          title: 'Topological gapless points in superconductors',
          author: '<u>Shuntaro Sumita</u>',
          conference: 'Tohoku University - RIKEN Joint Workshop — Math meets Quantum Materials —',
          location: 'Online (Zoom)',
          date: 'September 2020',
          invited: true
        },
        {
          title: 'Classification theory of topological crystalline gapless superconductivity',
          author: '<u>Shuntaro Sumita</u>',
          conference: '3rd EPiQS-TMS Alliance Workshop on Topological Phenomena in Quantum Materials',
          location: 'Kavli Institute for Theoretical Physics (Santa Barbara, USA)',
          date: 'October 2019',
          invited: false
        },
        {
          title: 'Classification of topological crystalline superconducting nodes on high-symmetry line',
          author: '<u>Shuntaro Sumita</u>, Takuya Nomoto, Ken Shiozaki, and Youichi Yanase',
          conference: 'APS March Meeting 2019',
          location: 'Boston Convention and Exhibition Center (Boston, USA)',
          date: 'March 2019',
          invited: false,
          number: 'L05.00003'
        },
        {
          title: 'Unconventional gap structure depending on angular momentum',
          author: '<u>Shuntaro Sumita</u> and Youichi Yanase',
          conference: '21st International Conference on Magnetism',
          location: 'Moscone Center (San Francisco, USA)',
          date: 'July 2018',
          invited: false,
          number: 'M9-02'
        },
        {
          title: 'Multipole Superconductivity and Unusual Gap Closing — Application to Sr<sub>2</sub>IrO<sub>4</sub> and UPt<sub>3</sub> —',
          author: '<u>Shuntaro Sumita</u> and Youichi Yanase',
          conference: 'Novel Quantum States in Condensed Matter 2017',
          location: 'Kyoto Univ. (Kyoto, Japan)',
          date: 'November 2017',
          invited: false
        },
        {
          title: 'Superconductivity in higher-order magnetic multipole states of Sr<sub>2</sub>IrO<sub>4</sub>',
          author: '<u>Shuntaro Sumita</u>',
          conference: 'ETH-Amsterdam-Kyoto mini-workshop on multipole physics and ultrafast dynamics',
          location: 'Kyoto Univ. (Kyoto, Japan)',
          date: 'October 2017',
          invited: true
        },
        {
          title: 'Superconductivity coexisting with magnetic multipole orders in Sr<sub>2</sub>IrO<sub>4</sub>',
          author: '<u>Shuntaro Sumita</u>, Takuya Nomoto, and Youichi Yanase',
          conference: 'J-Physics 2017: International Workshop on Multipole Physics and Related Phenomena',
          location: 'Hachimantai Royal Hotel (Iwate, Japan)',
          date: 'September 2017',
          invited: false
        }
      ] as PresentationInfo[]
    }
  }
})
